import mixpanel from 'mixpanel-browser';

import { useGetLoggedInUser } from '@revelio/auth';
import { BuildADashTrackingEvents, FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import { isScreenerV2Page } from '../../utils/routing-helpers';
import { useEditMode } from '../EditModeProvider/EditModeProvider';
import {
  usePageConfig,
  useTabContentConfig,
} from '../PageConfigProvider/PageConfigProvider';
import { RevelioPageId } from '../PageConfigProvider/types';
import { usePageManager } from '../PageManagerProvider/PageManagerProvider';

export const useEditCurrentPage = ({
  isReportPage = false,
}: {
  isReportPage?: boolean;
} = {}) => {
  const { loggedInUser } = useGetLoggedInUser();
  const { editMode } = useEditMode();
  const { config } = usePageConfig();
  const { revelioPageId } = useTabContentConfig();
  const { editPage, clonePageDraft } = usePageManager();
  const customReportsIsEnabled = useUnleashFlag(FeatureFlag.CustomReports);

  const pageId = config.id;
  const isOwner = !!config && loggedInUser?.id === config.owner.id;
  const canEdit =
    (!isReportPage || customReportsIsEnabled) &&
    !isScreenerV2Page(revelioPageId) &&
    revelioPageId !== RevelioPageId.TALENT_DISCOVERY &&
    revelioPageId !== RevelioPageId.POSTING_DISCOVERY;

  const editCurrentPage = () => {
    if (!pageId) return;
    if (isOwner) {
      if (!editMode) editPage(pageId);
      mixpanel.track(BuildADashTrackingEvents.EDIT_PAGE, { page_id: pageId });
    } else {
      clonePageDraft(pageId);
      mixpanel.track(BuildADashTrackingEvents.CLONE_PAGE, { page_id: pageId });
    }
  };

  return {
    canEdit,
    label: isOwner ? 'Edit Page' : 'Copy and Edit Page',
    editCurrentPage,
  };
};
